<template>
	<div class="question-member">
		<div class="content-tip">
			保障缺口分析和家庭有着紧密联系，完整的家庭成员信息有助于我们为您提供全面的综合保障解决方案。
		</div>
		<div class="title">请选择您的家庭成员</div>
		<br />
		<p class="tip">(单选多选皆可，也可点击“+”添加更多）</p>
		<br />
		<ul class="flex-box choose-box">
			<li
				v-for="(item, i) in member"
				:key="i"
				@click="updateChecked(i, !item.checked, item.relation)"
			>
				<div v-if="item.relation == SELF" class="selected">
					<img
						:src="require(`./${item.gender == MALE ? 'n' : 'v'}@2x.png`)"
						alt=""
					/>
					<div>自己</div>
				</div>

				<div v-if="item.relation == MATE" :class="{ selected: item.checked }">
					<img
						:src="require(`./${item.gender == MALE ? 'n' : 'v'}@2x.png`)"
						alt=""
					/>
					<div>配偶</div>
				</div>

				<div
					v-else-if="item.relation == CHILD"
					:class="{ selected: item.checked }"
				>
					<img
						:src="
							require(`./${item.gender == MALE ? 'son' : 'daughter'}@2x.png`)
						"
						alt=""
					/>
					<div>{{ item.gender == MALE ? '儿子' : '女儿' }}</div>
				</div>
			</li>

			<li
				@click="showAddMember = true"
				v-if="memberChilds.length < MAX_MEMBER_CHILD"
			>
				<div>
					<div class="add-icon"></div>
					<div>添加</div>
				</div>
			</li>
		</ul>

		<van-popup
			lock-scroll
			:close-on-click-overlay="false"
			v-model="showAddMember"
		>
			<div class="popup-box">
				<div class="title">请选择添加的孩子</div>
				<br />
				<br />
				<div class="flex-box popup-flex">
					<div :class="{ selected: childGender == MALE }">
						<img src="./son@2x.png" alt="" @click="childGender = MALE" />
						<p>儿子</p>
						<div @click="showAddMember = false">取消</div>
					</div>
					<div :class="{ selected: childGender == FEMALE }">
						<img src="./daughter@2x.png" alt="" @click="childGender = FEMALE" />
						<p>女儿</p>
						<div
							class="popup-yes"
							:class="{ gray: childGender == '' }"
							@click="addChild(childGender)"
						>
							确定
						</div>
					</div>
				</div>
			</div>
		</van-popup>

		<div class="flex-box next-box">
			<div @click="back">上一步</div>
			<div @click="onClickNext" class="btn-next" sensor-click>
				选好了
			</div>
		</div>
	</div>
</template>

<script>
import { SELF, MATE, CHILD } from '../../../../enum/RELATION.js';
import { MALE, FEMALE } from '../../../../enum/GENDER.js';

//最多允许用户添加3名子女，当用户添加了3名子女，隐藏【+】的添加按钮。默认四名人员
const MAX_MEMBER_CHILD = 3;

export default {
	props: {
		index: Number, // 题目顺序
		updateAnswer: Function, // 更新答案
		next: Function,
		back: Function,
		gender: [String, Number],
		member: Array,
	},
	data() {
		this.SELF = SELF;
		this.MATE = MATE;
		this.CHILD = CHILD;

		this.MALE = MALE;
		this.FEMALE = FEMALE;

		this.MAX_MEMBER_CHILD = MAX_MEMBER_CHILD;

		return {
			showAddMember: false,
			childGender: '',
		};
	},
	computed: {
		memberChilds() {
			return this.member.filter(
				(item) => item.checked && item.relation == CHILD
			);
		},
	},
	methods: {
		onClickNext(e) {
			const text = e.target.innerText;
			console.log(`测评页-第${this.index}题:`, text);
			this.sensorsAdd('BDWebClick', {
				$element_content: text,
				$title: `测评页-第${this.index}题`,
			});

			this.sensorsAdd('BDanswerResult', {
				entrance_location: '',
				question_number: this.index,
				question: `请选择您的家庭成员`,
				answer: String(this.member.filter((item) => item.checked).length),
			});

			this.next();
		},
		updateChecked(i, checked, relation) {
			if (relation != SELF) {
				if (
					checked &&
					relation == CHILD &&
					this.memberChilds.length >= MAX_MEMBER_CHILD
				) {
					return;
				}
				this.updateAnswer('update', checked, i);
			}
		},
		addChild(gender) {
			if (gender != '') {
				this.updateAnswer('add', {
					relation: CHILD, // 和测评人的关系
					gender, // 性别
					age: '', // 年龄
					checked: true,
				});
				this.showAddMember = false;
				this.childGender = '';
			}
		},
	},
};
</script>

<style>
.van-popup--center {
	border-radius: 0.1rem;
}
</style>

<style scoped>
.title {
	font-size: 0.15rem;
	font-family: PingFang SC;
	font-weight: bold;
	color: #0f2742;
	line-height: 0.19rem;
	text-align: center;
}
.tip {
	text-align: center;
	font-size: 0.12rem;
	font-family: PingFang SC;
	font-weight: 500;
	color: #98adc5;
	line-height: 0.19rem;
}

.flex-box {
	display: flex;
	justify-content: center;
	align-items: center;
}
.choose-box {
	justify-content: left;
	flex-wrap: wrap;
}
ul > li > div {
	position: relative;
	text-align: center;
	margin: 0 0.23rem;
}
ul > li > div > img {
	width: 0.7rem;
	height: 0.7rem;
}

ul > li > div > div {
	font-size: 0.13rem;
	font-family: PingFang SC;
	font-weight: 500;
	color: #0f2742;
	line-height: 0.4rem;
}

ul > li > div > .add-icon {
	width: 0.7rem;
	height: 0.7rem;
	border-radius: 50%;
	background: url('./add@2x.png') no-repeat center center, #e8ecf0;
	background-size: 0.3rem 0.3rem;
}

.selected::before {
	display: block;
	content: '';
	width: 0.21rem;
	height: 0.21rem;
	background: url('./y@2x.png') no-repeat;
	background-size: cover;
	position: absolute;
	top: 0.6rem;
	left: 50%;
	transform: translateX(-50%) translateY(0%);
}

.next-box {
	position: fixed;
	bottom: 0;
	width: 100%;
	justify-content: space-between;
	padding: 0 0.2rem 0.2rem;
	box-sizing: border-box;
	background: transparent;
}
.next-box > div {
	padding: 0.06rem 0.16rem;
	font-size: 0.13rem;
	font-weight: 500;
	color: #bbc3ca;
	line-height: 0.19rem;
}
.next-box > div:nth-child(1) {
	border-radius: 0.15rem;
	border: 1px solid #3b97ff;
	color: #3b97ff;
    background: white;
}
.next-box .btn-next {
	font-size: 0.14rem;
	color: #ffffff;
	background: #3b97ff;
	border-radius: 0.15rem;
}

/* 弹窗 */
.popup-box {
	width: 2.8rem;
	background: white;
	border-radius: 0.2rem;
	padding: 0.21rem 0.44rem;
	box-sizing: border-box;
}
.popup-flex {
	justify-content: space-between;
	text-align: center;
}
.popup-flex img {
	width: 0.7rem;
	height: 0.7rem;
}
.popup-flex > div {
	position: relative;
}
.popup-flex > div::before {
	transform: translateX(-50%) translateY(-10%);
}
.popup-flex > div > p {
	font-size: 0.13rem;
	font-weight: 500;
	color: #0f2742;
	line-height: 0.19rem;
	margin: 0.2rem 0;
}
.popup-flex > div > div {
	padding: 0.08rem 0.24rem;
	font-size: 0.13rem;
	font-weight: 500;
	color: #bbc3ca;
}
.popup-flex .popup-yes {
	background: #3b97ff;
	color: white;
	border-radius: 0.18rem;
}
</style>
